<template>
    <button
        v-tippy="t('editorSplitCell')"
        :class="[buttonState(editor.can().splitCell()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().splitCell()"
        @click="editor.chain().focus().splitCell().run()"
    >
        <MdiTableSplitCell class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTableSplitCell from 'materialdesignicons-vue3/icons/MdiTableSplitCell.js';

    defineExpose({
        name: 'TableSplitCellsButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
